import React from 'react';
import SpaceRoleRequiredUsersForm from './SpaceRoleRequiredUsersForm';

function SpaceSettingHelpDeskManger(props) {
  return (
    <SpaceRoleRequiredUsersForm
      {...props}
      role="helpdesk"
      description="账号管理人员有权限阅览和修改账号信息"
    />
  );
}

export default SpaceSettingHelpDeskManger;
